import { getLocale } from "../runtime";

const sv_categories = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kategorier`
};

const categories = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_categories(inputs)
	return "categories";
};

export { categories as "categories" };